export default __webpack_public_path__ + "static/media/logoSAB.5f11c4fc.jpg";